export default __webpack_public_path__ + "static/media/PaymentFailed.300738aa.png";